
<template>
  <base-info-card-marker @click="handleClick" :marker_color="task.json_attributes.color">
    <template slot="icon">
      <!-- <v-col cols="12" sm="3" md="3" class="pa-0"> -->
        <v-icon>mdi-check-circle-outline</v-icon>
        <!-- <span class="mx-1 black--text ">{{task.name}}</span> -->

      <!-- </v-col> -->
    </template>


    <template slot="text">
      <span class="mx-1 black--text ">{{task.name}}</span>

      <v-col cols="12" sm="5" md="3" lg="3" class="pa-0 ml-sm-4 my-2 my-sm-0 black--text" align='center' v-if="with_status">
        <b class=""> {{ $t('status') }}:</b>
        <!-- <span class="ml-2">{{  $t(`tasks.statuses.${task.status}`) }}</span> -->

        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-avatar v-on="on" size="20" :color="`status_${task.status}`" class="ml-1">
              <v-icon x-small  :color="`status_${task.status}_dot`">mdi-circle</v-icon>
            </v-avatar>
          </template>
          {{ $t(`tasks.statuses.${task.status}`) }}
        </v-tooltip>
      </v-col>
    </template>



    <template slot="last">
      <v-col class="pa-0 ml-0 ml-sm-4 black--text" align='right'>
        <v-tooltip top v-if="with_subtasks">
          <template v-slot:activator="{on}">
            <v-chip color="grey lighten-3" small class="my-1 my-sm-0 mr-2" v-on="on">
              <v-avatar left>
                <v-icon size="20">mdi-format-list-checkbox</v-icon>
              </v-avatar>
              {{ task.json_attributes.subtasks.length }}
            </v-chip>
          </template>
          {{ $t('tasks.subtasks.subtasks') }}
        </v-tooltip>
        
        <template v-if="with_users">
          <v-tooltip top v-for="(user,idx) in task.user_names" :key="user+idx">
            <template v-slot:activator="{on}">
              <v-icon v-on="on" :color="colors[idx % colors.length] " class="mr-2">
                mdi-account-circle
              </v-icon>
            </template>
            {{ user }}
          </v-tooltip>
        </template>
        
        <v-chip small color="whitegrey">
          <v-avatar left>
            <v-icon small color="primary">mdi-calendar</v-icon>
          </v-avatar>
          {{ task.start_at && $dayjs(task.start_at).format('DD/MM/YY') || '??' }} 
          ~ 
          {{ task.due_at && $dayjs(task.due_at).format('DD/MM/YY') || '??' }}
        </v-chip>
      </v-col>
    </template>
  </base-info-card-marker>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'TaskSmallCard',
  //mixins: [ validations ],
  props: {
    with_users: {
      type: Boolean,
      default: false,
    },
    with_subtasks: {
      type: Boolean,
      default: false,
    },
    with_status: {
      type: Boolean,
      default: false,
    },
    task: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    return {
      colors: [
        'primary',
        'secondary',
        'accent',
        'info',
      ]
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', {...e, task_id: this.task.id})
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>